<epic-icon [name]="iconName()" />
